import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

import AdviceSection from '../common/AdviceSection';

import images from '../../style/img/flag/images';

import { getNationalStrategiesCountries } from '../../api';

const NationalStrategies = props => {
	
	const [countries, setCountries] = useState([]);
	const [countriesFiltered, setCountriesFiltered] = useState([]);
	const [alphabet, setAlphabet] = useState([]);
	const [alphabetFiltered, setAlphabetFiltered] = useState([]);

	useEffect(() => {
		// Update the title of the page
		document.title = props.literals.L22007 +  " - " + props.literals.L22020 + " - " + props.literals.L363;

		getNationalStrategiesCountries()
		.then((res) => {

			const countryValues = res.resultset.sort((a, b) => {
				if (a.name == "EU27" || (a.name < b.name && b.name != "EU27"))
				{
					return -1
				}
				else
				{
					return 1
				}
			});

			setCountries(countryValues);
		})
	}, [])

	useEffect(() => {
		filterCountries();
		createLetterNavigation();
	}, [countries])

	const createLetterNavigation = () => {
		let letter = "";
		let index = "";
		let temporalArray = [];
		for (let i=0; i < countries.length; i++)
		{
			if (countries[i] != null)
			{
				letter = countries[i].name.charAt(0);
				index = temporalArray.indexOf(letter);

				if(index == -1){
					temporalArray.push(letter);
				}
			}
		}
		temporalArray.sort();
		setAlphabet(temporalArray);
	}

	const resetFilter = () => {
		setAlphabetFiltered([]);
		setCountriesFiltered(countries);
	}

	const addLetter = (letter) => () => {
		let temporalArray = alphabetFiltered;
		if (temporalArray.indexOf(letter) == -1)
        {
			temporalArray.push(letter); 
        }
        else
        {
			temporalArray.splice(temporalArray.indexOf(letter), 1);
        }
		
		setAlphabetFiltered(temporalArray);
		filterCountries();
	}

	const filterCountries = () => {
		let temporalArray = [];
		if (alphabetFiltered.length === 0)
		{
			temporalArray = countries;
		}
		else
		{
			countries.filter(country => alphabetFiltered.indexOf(country.name.charAt(0)) != -1).forEach(filteredCountry => {
				temporalArray.push(filteredCountry);
			});
		}

		setCountriesFiltered(temporalArray);
	}

	const filterAlphabet = (letter) => {
		if (alphabetFiltered.indexOf(letter) == -1)
        {
			return "";
		}else{
			return "active";
		}
	}

	return(
		<div>
			<AdviceSection literals = { props.literals } section = { ["osh-steering","national-strategies"] } methodologyData = { {section: 'osh-steering', subsection: 'Structure of each National strategy', indicator: 46 } } />

			<section className="filter--letter--section container">
				<ul className="filter--letter--list">
					{/* FILTER BY LETTER */}
					{
						alphabet.map( (letter, index) => (
							<li className="filter-letter-item" key={index}>
								<a onClick={ addLetter(letter) } className = { filterAlphabet(letter) } >{letter}</a>
							</li>
						))
					}

					<li className="reset-item">
						<button onClick={ resetFilter } className="btn-default btn-main-color btn-reset">{ props.literals.L20628 }</button>	
					</li>
				</ul>
			</section>

			<div className="line background-main-light"></div>
			<section className="national--card--section">
				<div className="card--grid xxs-w1 xs-w3 md-w3 w4 container">
					{
						countriesFiltered.map( (country,index) => (
							<div className="card--block--rounded national--card--item" key={index}>
								<div className="resources-item">
									<p className="nopadding additional-img text-center">
										<img className="flags--wrapper" src = { `${images[ country.code.toLowerCase() ]}` } alt = { country.name } />
									</p>
									<h2 className="text-center">{ country.name }</h2>
									<p className="btn--block-full left-text">
										<Link to = { "/osh-steering/country-profile/basic-information/"+country.code } className="btn-default btn-main-color btn-full" title = { country.code != "EU27_2020" ? props.literals.L20626 : props.literals.L20562}>{country.code != "EU27_2020" ? props.literals.L20626 : props.literals.L20562 }</Link>
									</p>
									{ country.code != "EU27_2020" && 
										<p className="btn--block-full left-text">
											<Link to = { "/osh-steering/eu-challenges-response/"+country.code } className="btn-default btn-main-color btn-full" title = { props.literals.L20625 } >{ props.literals.L20625}</Link>
										</p>
									}
								</div>
							</div>
						))
					}
				</div>
			</section>

		</div>
	)
}
NationalStrategies.displayName = 'NationalStrategies';
export default NationalStrategies;